<template>

<div class="item" v-on:click="onLinkClick" v-tooltip="(hasLink) ? tooltip : false" :class="{'is-grow': grow, 'is-faded': faded, 'is-empty': isEmpty, 'is-fixed': isFixed, 'is-end': isEnd, 'is-graph': graph, 'has-item': item, 'is-start': isStart, 'is-metric': isMetric, 'has-link': hasLink}" :data-theme="theme">

	<div class="item-label" v-if="label">{{ label }}<template v-if="isMetric && value !== 1 && !noPlural">s</template></div>

	<div class="item-value" v-if="graph">

		<app-graph :type="graph" :options="value.options || {}" :data="value.data || value" class="item-graph" />

	</div>

	<div class="item-value" v-if="!graph">

		<div class="item-tag" v-if="tag" :data-status="status">{{ tag }}</div>

		<app-icon class="item-icon" :icon="icon" v-if="icon" />

		<a :href="'mailto:' + value" v-if="isEmail">{{ value }}</a>

		<template v-if="item && !value">

			{{ item.name || item.reference }}

		</template>

		<div class="item-days" v-if="days">
		
			<div class="item-days-item" v-for="day in days" :key="day.value" v-tooltip="day.text" :class="{'is-active': $_.contains(active, day.value)}">{{ day.short }}</div>

		</div>
		
		<template v-if="!isEmail && (value || alt)">{{ (alt) ? value || alt : value }}</template>
		<span v-if="subvalue" class="item-subvalue">/ {{ subvalue }}</span>
		<span v-if="reference" class="item-reference">{{ reference }}</span>

		<div class="item-note" v-if="note">{{  note  }}</div>

		<slot></slot>

		<app-icon icon="info" class="item-link is-preview" v-if="item" v-on:click="onPreviewClick" v-tooltip="preview.tooltip[type]" />

	</div>

	<app-icon icon="open" class="item-link" v-if="hasLink" v-tooltip="(tooltip) ? false : 'Click to view'" />

    <com-preview v-if="is.previewing" :type="type" :id="item.id" v-on:close="is.previewing = false" v-on:manage="onPreviewFollow" />

</div>

</template>

<script>

import mixPreview from './../../../preview/mixin'

export default {

	props: ['label', 'tag', 'status', 'alt', 'type', 'graph', 'isMetric', 'unlinkable', 'reference', 'noPlural', 'tooltip', 'note', 'isEnd', 'isStart', 'days', 'active', 'theme', 'faded', 'isFixed', 'value', 'subvalue', 'icon', 'isEmpty', 'grow', 'isEmail', 'link'],

    mixins: [mixPreview],

	computed: {
	
		hasLink: function() {
		
			return this.link && (!this.unlinkable || (this.unlinkable && this.value))
		
		}

	},
	
	methods: {
	
		onLinkClick: function() {

			if (this.hasLink) this.$router.push(this.link)
		
		}
	
	}

}

</script>

<style scoped>

.item {
	flex-shrink: 0;
	flex-basis: 0;
	padding: 20px;
	border: 1px solid #eee;
	background-color: #fff;
	border-left: 0px;
	box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px;
}

.item.is-end {
	margin-right: 10px;
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
}

.item.is-start {
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
	border-left: 1px solid #eee;
}

.item:first-child {
	border-left: 1px solid #eee;
}

.item:first-child {
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
}

.item:last-child {
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
}

.item.is-fixed {
	min-width: 120px;
}

.item.is-metric {
	min-width: 100px;
	flex-basis: auto;
	padding: 20px 20px;
}

.item[data-theme="grey"] {
	background-color: #939393;
	border-width: 0px;
}

.item[data-theme="blue"] {
	background-color: #4082d3;
	border-width: 0px;
}

.item[data-theme="green"] {
	background-color: #4faa80;
	border-width: 0px;
}

.item[data-theme="red"] {
	background-color: #c55b5b;
	border-width: 0px;
}

.item[data-theme="yellow"] {
	background-color: #ffbe7a;
	border-width: 0px;
	color: #333;
}

.is-mobile .item {
	border-right: 0px;
	padding: 10px;
	border-bottom: 1px solid #ddd;
}

.item.is-grow {	
	flex-grow: 1;
}

.item-label {
	font-size: 12px;
	font-weight: 400;
	color: #666;
	white-space: nowrap;
}

.item.is-metric.has-link:hover .item-label {
	color: #fff;
}

.item.is-metric {
	display: flex;
	flex-direction: column-reverse;
}

.item.is-metric .item-label {
	text-align: center;
	white-space: wrap;
	height: 12px;
}

.item-value {
	font-size: 16px;
	margin-top: 10px;
	line-height: 20px;
	display: flex;
	color: #576067;
	align-items: center;
	white-space: nowrap;
}

.item.has-item .item-value {
	padding-right: 40px;
}

.item.is-metric.has-link:hover .item-value {
	color: #fff;
}

.item.is-metric .item-value {
	justify-content: center;
	margin-top: 0px;
	margin-bottom: 10px;
	font-weight: 500;
	line-height: 21px;
	font-size: 24px;
	align-items: flex-end;
}

.item.is-faded .item-value {
	color: #aaa;
}

.item[data-theme] .item-label {
	color: #fff;
}

.item[data-theme] .item-value {
	color: #fff;
}

.item[data-theme="yellow"] .item-label {
	color: #333;
}

.item.is-empty .item-value {
	color: #ccc;
}

.item-value a:hover {
	color: #4082d3;
}

.is-mobile .item-value {
	margin-top: 5px;
}

.item-tag {
	color: #fff;
	height: 20px;
	font-size: 16px;
	line-height: 20px;
	font-weight: 400;
	padding: 0px 4px;
	border-radius: 4px;
}

.item[data-theme] .item-tag {
	padding: 0px;
}

.item-tag[data-status="0"] {
	background-color: #c55b5b;
}

.item-tag[data-status="blue"] {
	background-color: #4082d3;
}

.item-tag[data-status="1"],
.item-tag[data-status="green"] {
	background-color: #4faa80;
}

.item-tag[data-status="2"],
.item-tag[data-status="red"] {
	background-color: #c55b5b;
}

.item-tag[data-status="3"],
.item-tag[data-status="yellow"] {
	background-color: #ffbe7a;
}

.item[data-theme="yellow"] .item-tag {
	color: #333;
}

.item-icon {
	font-size: 20px;
	margin-right: 10px;
	color: #4082d3;
}

.item:not(.is-metric).has-link .item-value {
	padding-right: 24px;
}

.item-link {
	cursor: pointer;
	color: #ccc;
	position: absolute;
    right: 10px;
	font-size: 16px;
	top: 44px;
}

.item[data-theme="blue"] .item-link {
	color: #fff;
}

.item-link.is-preview {
    right: 0px;
	font-size: 20px;
	top: 2px;
}

.item.is-metric .item-link {
	margin-left: 0px;
	right: 6px;
	top: 6px;
	font-size: 12px;
	line-height: 12px;
}

.item.is-metric.has-link:hover {
	background-color: #4082d3;
	border-color: #4082d3;
	cursor: pointer;
}

.item-link:hover {
	color: #333;
}

.item.is-metric.has-link:hover .item-link {
	color: #fff;
}

.item-note {
	padding-left: 8px;
	color: #aaa;
}

.item-note:before {
	content: '/';
	padding-right: 5px;
}

.item-days {
    display: flex;
    justify-content: center;
    align-items: center;
}

.item-days-item {
    width: 24px;
    margin: 1px;
    height: 24px;
    border-radius: 4px;
    background-color: #ddd;
    line-height: 24px;
    text-align: center;
    font-weight: 500;
    font-size: 12px;
    color: #999;
}

.item-days-item.is-active {
    color: #fff;
    background-color: #4082d3;
}

.item-subvalue {
	color: #ccc;
	font-size: 14px;
	line-height: 12px;
	margin-left: 3px;
}

.item-reference {
	color: #ccc;
	font-size: 14px;
	line-height: 12px;
	margin-left: 3px;
}

.item.is-graph {
	padding: 0px 0px 0px 0px;
}

.item.is-graph .item-value {
	margin-top: 0px;
	align-items: flex-end;
}

.item-graph {
	height: 83px;
	width: 100%;
	min-width: 128px;
}

</style>